module.exports = __webpack_public_path__ + "static/media/logo_fysiken.8807e7fd.png";